import { render, staticRenderFns } from "./store-sku.vue?vue&type=template&id=165b719f&scoped=true"
import script from "./store-sku.vue?vue&type=script&lang=js"
export * from "./store-sku.vue?vue&type=script&lang=js"
import style0 from "./store-sku.vue?vue&type=style&index=0&id=165b719f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b719f",
  null
  
)

export default component.exports